/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Ukrainian (Ukraine)
export default {
  'feedback-collector.anonymous': 'Цей відгук надсилається анонімно. Atlassian не зможе зв’язатися з вами безпосередньо щодо нього.',
  'feedback-collector.anonymous.title': 'Анонімний відгук',
  'feedback-collector.can-be-contacted.label': 'Так, команди Atlassian можуть зв’язуватися зі мною щодо моєї роботи з продуктами й службами Atlassian із метою вдосконалення їх. Я погоджуюся з <a>Політикою конфіденційності Atlassian</a>.',
  'feedback-collector.cancel-button.label': 'Скасувати',
  'feedback-collector.default.custom.textarea.label': 'Поділіться враженнями',
  'feedback-collector.enrol-in-research.label': 'Я хочу взяти участь у дослідженні продукту',
  'feedback-collector.feedback-title': 'Розкажіть, що ви думаєте',
  'feedback-collector.form.bug.label': 'Опишіть несправність або проблему',
  'feedback-collector.form.comment.label': 'Поділіться враженнями',
  'feedback-collector.form.empty.label': 'Виберіть один із варіантів',
  'feedback-collector.form.question.label': 'Про що б ви хотіли дізнатися?',
  'feedback-collector.form.suggestion.label': 'Розкажіть, що б ви хотіли покращити',
  'feedback-collector.option.bug.label': 'Повідомити про несправність',
  'feedback-collector.option.comment.label': 'Залишити коментар',
  'feedback-collector.option.default.label': 'Виберіть відгук',
  'feedback-collector.option.default.placeholder': 'Вибрати один',
  'feedback-collector.option.question.label': 'Поставити запитання',
  'feedback-collector.option.suggestion.label': 'Запропонувати покращення',
  'feedback-collector.required.fields.summary': 'Обов’язкові поля позначені зірочкою',
  'feedback-collector.submit-button.label': 'Надіслати відгук',
  'feedback-collector.success-flag.description': 'Ваші відгуки допомагають нам постійно покращувати продукти.',
  'feedback-collector.success-flag.title': 'Дякую!',
  'feedback-collector.summary-placeholder': 'Поділіться враженнями',
  'proforma-form-builder.feedback-icon-label': 'Залишити відгук',
  'proforma-form-builder.give-feedback': 'Залишити відгук'
};